const programs = [
  {
    id: "mandate",
    title: "Our Mandate",
    short: "Facilitating sustainable financing and private-led investment.",
    details: `We aim to:

            Facilitate access to sustainable financing for agro-processing companies, cooperatives, and farming clusters.

            Reduce the burden of public financing of Agriculture  and shift to private-led investment.

            Drive compliance, reduce default, and de-risk agro value chain investments.

            Power up rural agriculture through energy partnerships (off-grid and grid-aligned).

            Engage with government, Development Finance Institutions (DFIs), regulators, and MDAs for national replication.


`
  },
  {
    id: "Mission",
    title: "Our Mission",
    short: "Boost rural agriculture with structured energy and finance models.",
    details: `
            "To provide an enabling environment for agribusiness development through the efficient management of resources, deployment of improved technologies, and market facilitation for inclusive, sustainable, and profitable agricultural enterprise."

            (Adapted from Kaduna State Agricultural Policy)

          `
  },
    {
    id: "vision",
    title: "Our vision",
    short: "Boost rural agriculture with structured energy and finance models.",
    details: ` 
            A Nigeria where agriculture is a business, not a burden — where markets are structured, electricity powers production, and facilitation unlocks finance for those who feed the nation.

          
          `
  },
      {
    id: "About",
    title: "About Us",
    short: "Boost rural agriculture with structured energy and finance models.",
    details: `
              Access to Finance Program (The Prime Anchor Model – Private Sector-Led) is a strategic, results-driven intervention initiated under the Kaduna State Government and now gaining national attention for its potential to transform agricultural financing and productivity across Nigeria.

              We exist to provide a sustainable, non-subsidy-based model for empowering real agro-entities — farmers, processors, cooperatives, and integrated value chains — through facilitation, private financing, and market structuring.
            `
  },
      {
    id: "style",
    title: "What Makes Us Unique",
    short: "Boost rural agriculture with structured energy and finance models.",
    details: `
          We are private-sector-led, public-sector-recognized.

        We facilitate improving agro production and productivity to inputs supply.

        We operate with a full implementation framework (SIP & OGF).

        We are multi-sectoral, engaging power, finance, and development sectors.

        We coordinate three platforms under one leadership:

       🔹 Access to Finance Program<br/>
       🔹 Primeagro and Energy Facilitation Services Ltd
       🔹 Rights and Democracy Volunteers (RDV)

        `
  },
      {
    id: "Recognition",
    title: "Our Collaboration and Recognition",
    short: "Boost rural agriculture with structured energy and finance models.",
    details: `
          We are:

         Recognized by the Central Bank of Nigeria post-ABP reform. 

         In active discussion with SEC, FMFEC, Planning & Budget Commission, and SMEDAN. 

         Working with KAEDCO, REA, PUFF, and NIRSAL on powering agro-entities.

         Implementing recommendations from the Kaduna State Executive Council to expand prime anchors to tomatoes, ginger, sugarcane, and livestock.

         Strengthening engagement with rural markets across 255 wards in Kaduna State.


        `
  },
      {
    id: "Documents",
    title: "Our Core Documents",
    short: "Boost rural agriculture with structured energy and finance models.",
    details: `
          Strategic Implementation Plan (SIP) – 24 pages.

          Operational Guide Framework (OGF) – 10 pages.

          National Position Paper – for federal traction and replication.


        `
  },
      {
    id: "Philosophy",
    title: "Our Philosophy",
    short: "Boost rural agriculture with structured energy and finance models.",
    details: `
          We believe in replacing wasteful subsidy programs with smart, structured facilitation. Our program redefines the role of government as key enabler, supporter, facilitator not provider — and unlocks finance, infrastructure, and legitimacy for agro-entities to thrive sustainably.

        `
  },
      {
    id: "Priorities",
    title: "Priorities",
    short: "Boost rural agriculture with structured energy and finance models.",
    details: `
            Institutionalize the model in federal frameworks (NDP 2026–2030).

            Expand Prime Anchors to sugarcane, tomatoes, livestock, and ginger.

            Digitally structure rural markets in 255 Kaduna State wards as pioneer.

            Integrate off-grid energy solutions for agro-enterprises.

            Expand national recognition and attract private investment.


            “Agriculture is not a poverty trap. It is a business opportunity — when facilitated rightly.”



          
`
  },
      {
    id: "Contact",
    title: "Contact Us",
    short: "Boost rural agriculture with structured energy and finance models.",
    details: `
            We welcome engagement with:

            Development Finance Institutions (DFIs),

            State and Federal Ministries,

            Energy providers and regulators,

            Private investors, Prime Anchors,

            Researchers, cooperatives, agro-entrepreneurs,

            Donors, CSOs, and advocacy organizations.

          `
      },
]

export default programs
